import { jwtDecode } from "jwt-decode";

function Reducer(state, action) {
  if (Array.isArray(action)) {
    action.forEach((x) => {
      state = Reducer(state, x);
    });
    return state;
  } else {

    switch (action.type) {
      case "SET_READY":
        return { ...state, ready: action.payload };
      case "SET_PROFILE":
        return { ...state, profile: action.payload };
      case "SET_LOGGED":
        let isLogged = false;
        let jwt = null;
        let refreshToken = null;
        let profile = null;
        let jwtDecoded = null;
        let contaId = null;
        
        if (action.payload?.success && action.payload?.data) {
            const tokenData = action.payload.data;
            const accessToken = tokenData.accessToken;
            const refresh = tokenData.refreshToken;
            
            jwtDecoded = jwtDecode(accessToken);
            contaId = jwtDecoded["conta_id"];

            profile = {
              tipo_usuario: jwtDecoded["tipo_usuario"],
              name: jwtDecoded["unique_name"],
              email: jwtDecoded["email"],
              id: jwtDecoded["nameid"],
            };

            isLogged = true;
            jwt = accessToken;
            refreshToken = refresh;
            localStorage.setItem("jwt", jwt);

            if (refreshToken)
              localStorage.setItem("refreshToken", refreshToken);
            else
              localStorage.removeItem("refreshToken");
        } else {
          localStorage.removeItem("jwt");
          localStorage.removeItem("refreshToken");
        }

        return {
            ...state,
            contaId: contaId,
            jwtDecoded: jwtDecoded,
            isLogged: isLogged,
            jwt: jwt,
            profile: profile,
            refreshToken: refreshToken,
        };
      case "SET_LOADING":
        return { ...state, loading: action.payload };
      case "SET_TITLE_ICON":
        return { ...state, titleIcon: action.payload };
      case "SET_USER_PREFERENCES":
        return { ...state, userPreferences: action.payload };
      default:
        return state;
    }
  }
}

export default Reducer;
